import React, { useEffect } from "react";
import { Editor } from "primereact/editor";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";

const LIMIT_DIMENSION_IMG = 1000;

export default function InputEditorCustom({textValue ,onTextChange = () => {}, onTriggerSendMessage = () => {}, filesUploaded = [], onImagesUpload = () => {}, onFilesUpload = () => {}}) {

  const fileUploadRef = React.useRef(null);
  const editorRef = React.useRef(null);
  const toast = React.useRef(null);
  const [text, setText] = React.useState(textValue);

  const handleTextChange = (t) => {
    onTextChange(t);
    setText(t);
  };

  function extractTypeFile(text) {
    return text.split('/')[0].split(':')[1];
  }

  const onValidationFail = (event) => {
    const file = event;

    if (file?.size) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Arquivo muito grande',
        detail: `O arquivo ultrapassa o limite permitido.`,
        life: 3000
      });
    }
  };

  const customUploadHandler = async ({files}) => {
    const [file] = files;
    const formData = new FormData();
    formData.append('file', file);

    let base64String = '';
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
        base64String = reader.result;
        try {
            const typeFile = String(extractTypeFile(base64String)).toUpperCase();
            let element = ''

            if(typeFile !== 'IMAGE'){
              onFilesUpload([...filesUploaded, ...[{extension: file?.name?.split('.')[file?.name?.split('.').length - 1], label: file?.name, value: base64String}]]);
            }else{
              const img = new Image();
              const objectUrl = URL.createObjectURL(file);

              img.src = objectUrl;

              img.onload = () => {
                let width = img.width;
                let height = img.height;

                if (width > LIMIT_DIMENSION_IMG || height > LIMIT_DIMENSION_IMG) {
                  const aspectRatio = width / height;
                  if (width > height) {
                    width = LIMIT_DIMENSION_IMG;
                    height = Math.round(width / aspectRatio);
                  } else {
                    height = LIMIT_DIMENSION_IMG;
                    width = Math.round(height * aspectRatio);
                  }
                }

                element = `<img src="${base64String}" />`
                onImagesUpload([{src: base64String, width, height}])
                setText((prev) => (prev) ? prev + element : element);
              }; 
            }
            
            fileUploadRef.current.clear();
        } catch (error) {
            console.error('Upload failed:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Image upload failed.' });
        }
    };

  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey && text?.replace(/<\/?[^>]+>/g, '')?.trim()?.length) {
      event.preventDefault();
      if (editorRef.current && editorRef.current.getQuill()) {
        const quill = editorRef.current.getQuill();
        quill.deleteText(0, quill.getLength());
        onTriggerSendMessage();
      }
    }
  };

  const modules = {
      toolbar: {
          container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'script': 'sub'}, { 'script': 'super' }],
              [{ 'indent': '-1'}, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              // [{ 'color': [] }, { 'background': [] }],
              // [{ 'font': [] }],
              // [{ 'align': [] }],
              ['clean'],
              ['link', 'video'] // Include 'image' for image uploads
          ],
          // handlers: {
          //     'image': imageHandler // Assign your custom handler
          // }
      }
  };

  const uploadOptions = { icon: 'fa-solid fa-paperclip-vertical text-color-azul2 font-size-14', iconOnly: true,  className: 'bg-transparent border-0 p-0 pe-2 btn-upload-file-chat' };

  useEffect(() => {
    setText(textValue);
  }, [textValue]);

  return (
    <>
      <Toast ref={toast} /> 
      <FileUpload ref={fileUploadRef} mode="basic" chooseOptions={uploadOptions} uploadHandler={customUploadHandler} customUpload maxFileSize={1000000} auto onValidationFail={onValidationFail}/>
      <Editor className="w-100" ref={editorRef} onKeyDown={handleKeyDown} id="input-editor-custom" placeholder="Digite uma mensagem" showHeader={false} modules={modules} value={text} maxLength={250} onTextChange={(e) => {
        handleTextChange(e.htmlValue)        
      }}/>
    </>
  )
}